module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "senspro"
  }, [_vm._l((_vm.planichlist), function(item, index) {
    return _c('p', {
      key: index,
      attrs: {
        "title": "下载"
      },
      on: {
        "click": function($event) {
          _vm.fileclick(item)
        }
      }
    }, [_vm._v("\n    " + _vm._s(item.fileName)), _c('a', [_vm._v("下载")])])
  }), _vm._v(" "), (_vm.planichlistss) ? _c('p', [_vm._v("没有上传案例文件")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6193e468","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/digtization/casev.vue
// module id = 1236
// module chunks = 2